import invariant from 'ts-invariant';
import { ActorRef, EventObject, SendAction, forwardTo } from '@monofront/xstate-v4';

/**
 * Forward an event to a child machine which has the reference stored in the current's machine context.
 * @param contextKeyForActor the context key which references the child machine.
 * @returns xstate special action.
 */
export const safeForwardTo = <
  TContext,
  Key extends keyof TContext,
  U extends EventObject,
>(
  contextKeyForActor: Key,
) => {
  return forwardTo((context: TContext) => {
    const ref = context[contextKeyForActor] as ActorRef<U> | string;

    invariant(
      ref,
      `${String(contextKeyForActor)} must be present to handle forwardTo`,
    );

    return ref;
  }) as TContext[Key] extends string | ActorRef<U> | null | undefined
    ? SendAction<TContext, U, any>
    : never;
};
